/** Journey chip for one CAPI delivery. Kept out of the render site so the
 *  wording decision is unit-testable (same pattern as googleToggleOffHint). */
export interface CapiLabelInput {
  type: string;
  ok: boolean;
  /** The conversion went out through the twin channel; this row was
   *  deliberately not re-sent so the platform counts it once (TASK-94). */
  suppressed?: boolean;
}

export type CapiLabelTone = "sent" | "duplicate" | "failed";

const PLATFORM: Record<string, string> = {
  meta: "Meta",
  google: "Google",
  linkedin: "LinkedIn",
};

/**
 * Three states have to stay distinguishable at a glance:
 *   sent      — this event went to the platform itself
 *   duplicate — already sent via the other channel, not re-sent
 *   failed    — the platform rejected it
 * A failed send stays a failure even if it was a duplicate: a rejection is
 * never "already at the platform".
 */
export function capiLabel(d: CapiLabelInput): {
  text: string;
  tone: CapiLabelTone;
  /** Platform name without the suffix — for tooltips that read as a sentence. */
  platform: string;
} {
  const platform = PLATFORM[d.type] ?? d.type;
  if (d.ok === false) return { text: platform, tone: "failed", platform };
  if (d.suppressed)
    return { text: `${platform} (Duplikat)`, tone: "duplicate", platform };
  return { text: platform, tone: "sent", platform };
}
